import { Link } from '@tanstack/react-router'
import { Button, Tooltip } from 'antd'
import { Container } from 'lucide-react'
import { FC } from 'react'

export const AssetLink: FC<{
  unitId: string | undefined
  siteId: string | undefined
}> = ({ unitId, siteId }) => {
  if (!unitId || !siteId) {
    console.warn(
      'Unable to render asset link due to missing unit ID or site ID on Libra ticket'
    )
    return null
  }

  return (
    <Tooltip title='Open Asset'>
      <Link to='/assets/unit' search={{ unitId, siteId }}>
        <Button type='text'>
          <Container size={16} />
        </Button>
      </Link>
    </Tooltip>
  )
}
